export const environment = {
  production: true,
  // apiUrl: 'http://localhost:8082/api',
  apiUrl: '/api'
};
